
import React from 'react';
import { motion } from 'framer-motion';
import { Check, Users, Calendar, CreditCard, Settings } from 'lucide-react';

const PartnerSolution = () => {
  const benefits = [
    {
      icon: Users,
      text: "We install our fully licensed NP and curated treatment menu directly into your practice"
    },
    {
      icon: Check,
      text: "You keep your brand and your patients—we handle the rest"
    },
    {
      icon: Calendar,
      text: "Patients book through our app or your front desk"
    },
    {
      icon: CreditCard,
      text: "You earn monthly payouts"
    },
    {
      icon: Settings,
      text: "We manage staffing, training, equipment, and compliance"
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-5xl md:text-6xl font-serif font-light text-juv-deep-chestnut mb-6"
          >
            We Bring the Medspa to You
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-juv-terracotta/10 rounded-full flex items-center justify-center">
                  <benefit.icon className="w-6 h-6 text-juv-terracotta" />
                </div>
                <p className="text-xl text-juv-deep-chestnut leading-relaxed">
                  {benefit.text}
                </p>
              </div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="aspect-square bg-gradient-to-br from-juv-soft-blush/30 to-juv-rose-clay/30 rounded-3xl flex items-center justify-center">
              <div className="text-center p-8">
                <div className="text-6xl mb-4">🏥</div>
                <p className="text-lg text-juv-deep-chestnut/70">
                  Your practice + our medspa expertise = exponential growth
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnerSolution;
